module.exports = __webpack_public_path__ + "static/img/img_2.c606ccb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_2.jpg
// module id = m7TE
// module chunks = 1